export default "__VITE_ASSET__1uc7Mq3l__"